/**
 * M10 P4b4b (plan docs/plans/2026-10-15-m10-p4b.md §3.4; hull tiers spec §4.5): a kitted ship's name.
 * `kitShipName` fills the kit's `namePattern` from `kit-names.json`, picked by the agent serial hash; `kitSlots.ts`
 * keeps it per entity for the target readout. The kit def and its slots (P4b4c) are in `kits.ts` (`kitDef`,
 * `addKitSlots`) and `kitSlots.ts` (the lookups).
 */
import { z } from 'zod'
import namesJson from '../data/kit-names.json'
import type { ShipDef } from '../data/schemas'
import { kitHash, type Kit } from './kits'

const names = z
  .object({ comment: z.string(), name: z.array(z.string().min(1)).min(1), tally: z.array(z.string().min(1)).min(1) })
  .strict()
  .parse(namesJson)

/** `kit`'s ship name for agent `agentId` (`ag-<seq>`) on `base` (its `namePattern`). Rare. */
export function kitShipName(kit: Kit, base: ShipDef, agentId: string): string {
  const h = kitHash(`${agentId}#name`)
  const open = base.name.indexOf(' (')
  const full = open > 0 ? base.name.slice(0, open) : base.name
  const hull = full.slice(full.indexOf(' ') + 1)
  return kit.namePattern
    .replace('{name}', names.name[h % names.name.length])
    .replace('{tally}', names.tally[h % names.tally.length])
    .replace('{hull}', hull)
    .replace('{kit}', kit.name)
}
